import { render, staticRenderFns } from "./RoyaList.vue?vue&type=template&id=85e93894&"
import script from "./RoyaList.vue?vue&type=script&lang=js&"
export * from "./RoyaList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports